import { redactUrlSecrets } from 'lib/helpers/redactUrlSecrets/redactUrlSecrets'

interface RedactSecretsInTextParams {
  text: string
}

const URL_BOUNDARY = `[^\\s"'()<>\`]`

// Absolute URLs anywhere, and relative paths that start a word: a path mid-word (`a/b`) is not a URL.
const ABSOLUTE_URL_PATTERN = new RegExp(`https?://${URL_BOUNDARY}+`, 'g')
const RELATIVE_URL_PATTERN = new RegExp(`(^|[\\s"'(<\`])(/${URL_BOUNDARY}+)`, 'g')

// A stack frame ends its URL with `:line:col`, which a query value would otherwise swallow.
const STACK_POSITION_SUFFIX = /(?::\d+)+$/

const redactUrlLike = (urlLike: string): string => {
  const suffix = STACK_POSITION_SUFFIX.exec(urlLike)?.[0] ?? ''
  const url = urlLike.slice(0, urlLike.length - suffix.length)

  return `${redactUrlSecrets({ url })}${suffix}`
}

export const redactSecretsInText = ({ text }: RedactSecretsInTextParams): string =>
  text
    .replace(ABSOLUTE_URL_PATTERN, redactUrlLike)
    .replace(RELATIVE_URL_PATTERN, (_, prefix: string, url: string) => `${prefix}${redactUrlLike(url)}`)
